import { ToggleButton } from "../StoryPreview";
import { deleteStory } from "services/stories";
import { removeFromCollection } from "services/users";
import { MoreItem } from "./MoreButton";
import { useUser } from "contexts";
import PropTypes from "prop-types";
import { Confirm } from "ui";

function DeleteButton({ mode, story, onClose }) {
  const { hasPermission } = useUser();

  if (!story.isOwner || !hasPermission("stories:delete")) return null;

  const handleDelete = () => {
    deleteStory(story._id).then(() => {
      removeFromCollection(story._id);
      onClose();
    });
  };

  return (
    <Confirm
      title="Eliminar historia"
      description="¿Estás seguro de que quieres eliminar esta historia? Esta acción no se puede deshacer."
      onConfirm={handleDelete}
      confirmText="Eliminar"
    >
      {mode === "menu" ? (
        <MoreItem icon="delete">Eliminar</MoreItem>
      ) : (
        <ToggleButton icon="delete" label="Eliminar" />
      )}
    </Confirm>
  );
}

DeleteButton.propTypes = {
  story: PropTypes.shape({
    _id: PropTypes.string.isRequired,
  }).isRequired,
  onClose: PropTypes.func.isRequired,
};

export default DeleteButton;
